import { omit } from 'lodash'

import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { AddSchema } from '../../schemas/addSchema'
import { Variables } from './api/types'

export const mapper = (data: AddSchema, ability: Ability): Variables => {
  const { divId, domainId, name, outOfPage, outOfPageType, pageIds, path, ybAdUnitEnabled } = data

  const constantFields: Pick<
    Variables,
    | 'divId'
    | 'domainId'
    | 'name'
    | 'outOfPage'
    | 'outOfPageType'
    | 'pageIds'
    | 'path'
    | 'ybAdUnitEnabled'
  > = {
    divId: divId || null,
    domainId,
    name: name || null,
    outOfPage,
    outOfPageType,
    pageIds: pageIds.right,
    path: path.toLowerCase(),
    ybAdUnitEnabled,
  }

  const variableFields: Pick<Variables, 'ybAdUnitEnabled'> = {
    ybAdUnitEnabled,
  }

  return {
    ...constantFields,
    ...omit(
      variableFields,
      fieldsToOmit<Variables>({
        ybAdUnitEnabled: ability.cannot('create', 'AdUnitField-ybAdUnitEnabled'),
      }),
    ),
  }
}
